import loadModuleOnElement from "../../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = ".site-title-edit";

export default function loadEditTitle(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
